import PropTypes from 'prop-types';
import SubscriptionRadioOptions from './SubscriptionRadioOptions';
import RadioButtonDetails from './RadioButtonDetails';

export default function RadioButtonWrapper({
  selectedProduct,
  products,
  setSelectedProductSku,
  isPairingFlow,
}) {
  return (
    <div>
      <SubscriptionRadioOptions
        products={products}
        setSelectedProductSku={setSelectedProductSku}
        selectedProduct={selectedProduct}
        isPairingFlow={isPairingFlow}
      />
      <RadioButtonDetails product={selectedProduct} />
    </div>
  );
}

RadioButtonWrapper.propTypes = {
  products: PropTypes.array.isRequired,
  setSelectedProductSku: PropTypes.func.isRequired,
  selectedProduct: PropTypes.object.isRequired,
};
